import { CommonUtility } from '@utility/common';

export const carrierImageMap: Record<string, string> = {
  dhl: CommonUtility.getCdnLink('integrations/dhl.png'),
  usps: CommonUtility.getCdnLink('integrations/usps-small.webp'),
  ups: CommonUtility.getCdnLink('integrations/ups.png'),
  fedex: CommonUtility.getCdnLink('integrations/fedex.png'),
};
